import React, { createContext, useContext, useState } from 'react';

const DevModeContext = createContext();

export const DevModeProvider = ({ children }) => {
  const [isDevMode, setIsDevMode] = useState(true);

  const toggleDevMode = () => {
    setIsDevMode(prev => !prev);
  };

  return (
    <DevModeContext.Provider value={{ isDevMode, toggleDevMode }}>
      {children}
    </DevModeContext.Provider>
  );
};

export const useDevMode = () => {
  const context = useContext(DevModeContext);
  if (context === undefined) {
    throw new Error('useDevMode must be used within a DevModeProvider');
  }
  return context;
}; 